import { TextField } from "@mui/material"
import React, { useState } from "react"
import useSound from "use-sound"
import { mouseOver } from "utils/sounds"
import { styles } from "./styles"
import { useAuthContext } from "contexts/AuthContext"

export default function TextInput(props) {
  const { audioSettings } = useAuthContext()
  const [play] = useSound(mouseOver, {
    volume: 0.5,
    soundEnabled: audioSettings?.enabledAudioEffects,
    html5: false,
  })
  const [played, setPlayed] = useState()
  const onFocus = () => {
    if (!played) {
      play()
      setPlayed(true)
    }
    if (props?.onFocus) props.onFocus()
  }

  const onBlur = () => {
    setPlayed(false)
    if (props?.onBlur) props.onBlur()
  }

  return (
    <TextField
      autoComplete="off"
      size="small"
      onKeyDown={(e) => {
        if (!props?.onSubmit) return
        if (e.key === "Enter") {
          props.onSubmit(e)
        }
      }}
      {...props}
      onClick={onFocus}
      onBlur={onBlur}
      sx={[styles.textField, props?.sx]}
      InputProps={{
        ...props?.InputProps,
        sx: [styles.inputBox, props?.InputProps?.sx],
      }}
      onPaste={(e) => e.preventDefault()}
      onDragStart={(e) => {
        e.preventDefault()
        return false
      }}
      onDrop={(e) => {
        e.preventDefault()
        return false
      }}
    />
  )
}
